module.exports = __webpack_public_path__ + "static/DarksideDetective7-6f205108ddecd68c2258a7b547c5c43b.webp";